var render = function render(){var _vm=this,_c=_vm._self._c;return _c('administration-layout',[_c('div',{staticClass:"pt-12"},[_c('div',{staticClass:"text-xl font-bold"},[_c('h1',[_vm._v("Catálogos")])])]),_c('div',{staticClass:"flex flex-col items-center py-4"},[_c('div',{staticClass:"w-full xl:px-36 sm:px-8"},[_c('div',{staticClass:"flex flex-col space-y-6"},[_c('content-card',[_c('devices')],1)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }